<template>
  <div class="phonebox" ref="block" :style="style">
    <img src="../img/phone.svg"  :style="style">
    <div class="absolute-item" ref="scroller">
      <div class="yo-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scale: {
      default: (window.innerHeight - 150) / 767
    }
  },
  data () {
    const maxScaler = 1.35
    return {
      maxScaler,
      goscale: this.scale > maxScaler ? maxScaler : this.scale,
      style: {
        height: `${767 * this.goscale}px`,
        width: `${393 * this.goscale}px`
      }
    }
  },
  mounted () {
    let tt = 0
    window.addEventListener('resize', () => {
      clearTimeout(tt)
      tt = setTimeout(() => {
        let rect = {
          top: 180
        }
        if (this.$refs['block']) {
          rect = this.$refs['block'].getBoundingClientRect()
        }
        this.goscale = (window.innerHeight - rect.top - 15) / 767
        if (this.goscale > this.maxScaler) {
          this.goscale = this.maxScaler
        }
        this.style = {
          height: `${767 * this.goscale}px`,
          width: `${393 * this.goscale}px`
        }
      }, 30)
    })
    window.dispatchEvent(new Event('resize'))
  },
  methods: {
    toBottom () {
      const scroller = this.$refs['scroller']
      if (scroller) {
        scroller.scrollTop = scroller.scrollHeight
        setTimeout(() => {
          scroller.scrollTop = scroller.scrollHeight
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.phonebox{
  position: relative;
  width: 393px;
  height: 767px;
}
.absolute-item{
  position: absolute;
  top: calc(64 / 767 * 100%);;
  left: calc(21 / 393 * 100%);
  width: calc(350 / 393 * 100%);
  height: calc(628 / 767 * 100%);
  background-color: white;
  border: #5d410e solid 1px;
  border-radius: 4px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.yo-content{
  margin: 20px;
}
</style>
